<template>
  <div class="result-input">
    <div class="text-center">
      <v-progress-circular v-if="isLoading" indeterminate color="secondary" />
    </div>
    <div class="sticky_card_buttons" v-if="!isLoading" style="z-idenx: 10">
      <v-btn
        @click="userResultCsv(item)"
        :loading="isSubmitting"
        color="info"
        outlined
        class="ma-3 hidden-sm-and-down"
        style="width:120px; float:left"
      >
        CSV出力
      </v-btn>
    </div>
    <v-alert
      v-if="!isStartedCampaign && !isLoading"
      border="left"
      colored-border
      type="info"
      elevation="2"
      style="font-size: 90%"
    >
      記録開始日（{{startDate}}）以降に記録詳細が表示されます。
    </v-alert>
    <table class="sticky_card_table" v-else-if="isStartedCampaign && !isLoading">
      <colgroup style="width: 100%">
        <col class="col_date" />
        <col class="col_is_input" />
        <col v-for="(course) of selectedCourseList" :key="course.name" :class="'col_course_'+course.result_type" />
      </colgroup>
      <thead>
        <tr>
          <th style="width:15%">日付</th>
          <th style="width:5%">入力</th>
          <th v-for="(course) of selectedCourseList" :key="course.id">
            {{course.name}}
            <span v-if="course.custom_goal_setting">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" small>mdi-note</v-icon>
                </template>
                <span>{{course.custom_objective}}</span>
              </v-tooltip>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>{{totalDate}}日中のクリア</th>
          <th></th>
          <th v-for="(course) of selectedCourseList" :key="course.id">
            <span v-if="course.aggregate_result_info.is_completed" class="pink--text">
              <v-icon color="pink">mdi-seal-variant</v-icon>
              達成
            </span>
            <span v-else>
              <span v-if="course.complete_type === 'Daily_CircleAndCross' || course.complete_type === 'Daily_StandardValue'">
                {{course.aggregate_result_info.clear_count}}日クリア
              </span>
              <span v-else-if="course.complete_type === 'Weekly_CircleAndCross'">
                {{course.aggregate_result_info.clear_count}}週クリア
              </span>
              <span v-else-if="course.complete_type === 'UpperLimit'">
                {{course.aggregate_result_info.clear_count}}回クリア
              </span>
              <span v-else-if="course.complete_type === 'UpperLimi'">
                {{course.aggregate_result_ingo.clear_count}}回クリア
              </span>
            </span>
          </th>
        </tr>
        <tr v-for="(dateValue) of dailyValueList" :key="dateValue.date" :class="dateValue.day === 0 || dateValue.day === 6 ? 'background_blue' : ''">
          <td style="text-align:center">
            <span v-if="dateValue.is_today" class="pink--text font-weight-bold">TODAY!<br></span>
            <span :class="dateValue.day === 0 ? 'pink--text' : (dateValue.day === 6 ? 'indigo--text' : '')">{{dateValue.show_date}}</span>
          </td>
          <td style="text-align:center">
            <v-icon v-if="dateValue.is_inputted" color="light-green">mdi-check-circle</v-icon>
          </td>
          <td v-for="(course, index) of selectedCourseList" :key="course.id" style="text-align:center">
            <div v-if="course.result_type === 'Number'" style="width:100%; margin:0 auto; min-width: 70px important!;">
              <span v-if="dateValue.select_course_result[index].number || dateValue.select_course_result[index].number == '0'" style="font-size:12px" class="font-weight-black">
                〇
              </span>
            </div>
            <div v-if="course.result_type === 'Integer'" style="width:100%; margin:0 auto; min-width: 70px;">
              <span v-if="dateValue.select_course_result[index].integer || dateValue.select_course_result[index].integer == '0'" class="font-weight-black">
                {{dateValue.select_course_result[index].integer}}{{course.unit}}
              </span>
            </div>
            <div v-if="course.result_type === 'CircleAndCross'" style="width:100%; margin:0 auto;">
              <span v-if="dateValue.select_course_result[index].circle_and_cross == 'circle'" style="font-size:12px" class="font-weight-black">〇</span>
              <span v-else-if="dateValue.select_course_result[index].circle_and_cross == 'cross'" style="font-size:16px" class="font-weight-black">×</span>
            </div>
            <div v-else-if="course.result_type === 'CircleCrossNone'" style="width:100%; margin:0 auto;">
              <span v-if="dateValue.select_course_result[index].circle_and_cross == 'circle'" style="font-size:12px" class="font-weight-black">〇</span>
              <span v-else-if="dateValue.select_course_result[index].circle_and_cross == 'cross'" style="font-size:16px" class="font-weight-black">×</span>
              <span v-else-if="dateValue.select_course_result[index].circle_and_cross == 'none'" class="font-weight-black">該当なし</span>
            </div>
            <div v-else-if="course.result_type === 'DualInteger'" style="width:100%; margin:0 auto;">
              <span v-if="dateValue.select_course_result[index].has_dual_integer" style="font-size:12px" class="font-weight-black">
                〇
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
import JsonToCsv from '../../utils/JsonToCsv'
import UserResultCsv from '../../utils/UserResultCsv'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')

const listDailyResultForManageQuery = (campaignId, username) => `
  query listDailyResultForManage {
    listDailyResultForManage(campaign_id: "${campaignId}", username: "${username}") {
      campaign_id
      select_course_list {
        id
        meta
        name
        result_type
        unit
        complete_type
        complete_value
        category
        objective
        basic_item
        recording_method
        detailed_document_file_name
        youtube_url
        youtube_thumbnail_file_name
        aggregate
        participants
        is_display_graph
        custom_goal_setting
        aggregate_result_info {
          id
          course_id
          point
          input_count
          total
          average
          rank
          custom_objective
          clear_count
          is_completed
        }
      }
      daily_results {
        id
        meta
        is_inputted
        top_blood_pressure
        bottom_blood_pressure
        note
        select_course_result {
          id
          meta
          course_id
          circle_and_cross
          integer
          number
          dual_integer_1
          dual_integer_2
        }
      }
      campaign_user {
        id
        total_point
        is_prizewinner
        course
        custom_objective_list {
          course_id
          custom_objective
        }
      }
    }
  }
`
const getListDailyResultForManage = async (campaignId, username) => {
  const { data: { listDailyResultForManage: data } } = await GraphqlAPI(listDailyResultForManageQuery(campaignId, username))
  return data
}

export default {
  mixins: [JsonToCsv, UserResultCsv],
  name: 'resultPanel',
  data () {
    return {
      dailyValueList: [],
      targetDateList: [],
      originDailyValueList: [],
      selectedCourseList: [],
      startDate: null,
      totalDate: null,
      isLoading: false,
      isSubmitting: false,
      isStartedCampaign: false
    }
  },
  props: [
    'targetUser'
  ],
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    }
  },
  watch: {
    targetUser: {
      async handler (newValue) {
        if (newValue !== null) {
          this.isLoading = true
          this.originDailyValueList = await getListDailyResultForManage(this.campaign.id, this.targetUser.username)
          if (this.originDailyValueList !== null) {
            this.resultListFormatter()
          }
          this.isLoading = false
        }
      },
      deep: true
    }
  },
  async created () {
    if (!this.campaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    this.isLoading = true
    // 対象期間の取得
    this.startDate = dayjs(this.campaign.start, 'YYYY-MM-DD').format('M/D')
    const startDate = dayjs(this.campaign.start, 'YYYY-MM-DD')
    const endDate = dayjs(this.campaign.end, 'YYYY-MM-DD')
    this.isStartedCampaign = dayjs() >= startDate
    let countDate = startDate.clone()
    while (countDate.unix() <= endDate.unix() && countDate <= dayjs()) {
      this.targetDateList.push(countDate.format('YYYY-MM-DD'))
      countDate = countDate.add(1, 'days')
    }
    this.targetDateList.reverse()
    this.totalDate = endDate.diff(startDate, 'days') + 1

    // 記録情報の取得
    this.originDailyValueList = await getListDailyResultForManage(this.campaign.id, this.targetUser.username)
    if (this.originDailyValueList !== null) {
      this.resultListFormatter()
    }
  },
  methods: {
    resultListFormatter () {
      this.isLoading = true
      this.dailyValueList = []
      this.selectedCourseList = []
      const dailyResultList = this.originDailyValueList.daily_results
      const selectedCourseList = this.originDailyValueList.select_course_list
      const descTargetDateList = Array.from(this.targetDateList)
      const me = this
      const campaignUser = this.originDailyValueList.campaign_user

      for (const selectedCourse of this.originDailyValueList.select_course_list) {
        const targetCourse = campaignUser.custom_objective_list.find(elm => {
          return elm.course_id === selectedCourse.id
        })
        this.selectedCourseList.push({
          ...selectedCourse,
          custom_objective: targetCourse.custom_objective
        })
      }

      for (const date of descTargetDateList) {
        const dailyResultObj = dailyResultList.find(elm => date === elm.meta)
        // 対象日の結果情報があるとき
        if (dailyResultObj) {
          const valueObj = {
            date: dayjs(dailyResultObj.meta).format('YYYY-MM-DD'),
            show_date: dayjs(dailyResultObj.meta).format('YYYY/MM/DD(dd)'),
            day: dayjs(dailyResultObj.meta).day(),
            is_today: dailyResultObj.meta === dayjs().format('YYYY-MM-DD'),
            is_inputted: dailyResultObj.is_inputted,
            top_blood_pressure: dailyResultObj.top_blood_pressure,
            bottom_blood_pressure: dailyResultObj.bottom_blood_pressure,
            note: dailyResultObj.note,
            disp_note: dailyResultObj.note
          }
          if (dailyResultObj.select_course_result) {
            const courseList = []
            for (const selectCourse of selectedCourseList) {
              const existCourse = dailyResultObj.select_course_result.find(pastCourseResult => {
                return pastCourseResult.course_id === selectCourse.id
              })
              courseList.push({
                course_id: selectCourse.id,
                circle_and_cross: existCourse ? existCourse.circle_and_cross : null,
                integer: existCourse ? existCourse.integer : null,
                number: existCourse ? existCourse.number : null,
                dual_integer_1: existCourse ? existCourse.dual_integer_1 : null,
                dual_integer_2: existCourse ? existCourse.dual_integer_2 : null,
                has_dual_integer: existCourse ? existCourse.dual_integer_1 || existCourse.dual_integer_1 === 0 || existCourse.dual_integer_2 || existCourse.dual_integer_2 === 0 : false
              })
            }
            valueObj.select_course_result = courseList
          }
          me.dailyValueList.push(valueObj)

        // 対象日の結果情報がないとき（空のオブジェクトを返す）
        } else {
          const selectCourseResult = []
          for (const elm of selectedCourseList) {
            selectCourseResult.push({
              course_id: elm.id,
              circle_and_cross: null,
              integer: null,
              number: null,
              dual_integer_1: null,
              dual_integer_2: null
            })
          }
          const obj = {
            date: dayjs(date).format('YYYY-MM-DD'),
            show_date: dayjs(date).format('YYYY/MM/DD(dd)'),
            day: dayjs(date).day(),
            is_today: date === dayjs().format('YYYY-MM-DD'),
            is_inputted: false,
            top_blood_pressure: null,
            bottom_blood_pressure: null,
            note: null,
            select_course_result: selectCourseResult
          }
          me.dailyValueList.push(obj)
        }
      }
      this.isLoading = false
    },
    async userResultCsv () {
      try {
        this.isSubmitting = true
        const username = this.targetUser.username
        // ユーザー単位結果詳細CSV出力、util.UserResultCsvのmixinを使用
        const dailyValueList = await getListDailyResultForManage(this.campaign.id, username)
        const selectedCourseList = dailyValueList.select_course_list
        // 対象期間の取得
        const targetDateList = this.$_getTargetDateList(this.campaign)
        // 記録情報の取得
        const dailyResults = this.$_resultListFormatter(dailyValueList, targetDateList)
        // CSV用に整形
        const csvData = this.$_generateUserResultCsvList(selectedCourseList, dailyResults)
        // CSV出力設定
        const csvTitle = this.targetUser.certificate_number + '_' + this.$_getDateString() + '.csv'
        const labels = Object.getOwnPropertyNames({ ...csvData[0] })
        const labelsConf = this.$_createCsvLabelsConf(labels)
        const separator = ','
        this.$_jsonToCsv(csvTitle, csvData, labelsConf, separator)
        this.isSubmitting = false
      } catch (e) {
        this.isSubmitting = false
        this.$emit('errorHandling', 'ユーザー結果CSVの生成に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    }
  }
}
</script>

<style lang="scss">
.sticky_card_table {
  font-size: 0.75rem;
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
  th, td {
    height: 30px;
    vertical-align: middle;
    padding: 5px;
    border: 1px solid #ccc;
  }
  thead th {
    position: -webkit-sticky; /* safari */
    position: sticky;
    top: 59px;
    color: #333;
    z-index: 2;
    background-color: #FFF8E1;
  }
  .col_date {
    width: 110px;
  }
  .col_is_input {
    width: 35px;
  }
  .col_blood_pressure {
    width: 70px;
  }
  .col_course_Number, .col_course_Integer {
    margin:0 auto;
    width: 100px;
    padding: 0 5px;
  }
  .col_course_CircleAndCross {
    margin:0 auto;
    width: 82px;
    padding: 0 5px;
  }
  .col_course_CircleCrossNone {
    margin:0 auto;
    width: 145px;
    padding: 0 5px;
  }
  .col_course_DualInteger {
    margin: 0 auto;
    width: 82px;
    padding: 0 5px;
  }
}
.sticky_card_buttons {
  position: -webkit-sticky; /* safari */
  position: sticky;
  top: 0px;
  height: 60px;
  z-index: 2;
  background: #FFFFFF;
  width: 100%;
  transform: translateX(0%);
}
.v-window {
  overflow: visible !important;
}
.background_blue {
  background-color: #E6F1FF;
}
.theme--light.v-btn.v-btn--has-bg {
  background-color: transparent;
}
</style>
